/**
 * FDA Orange Book Application Type ("Appl_Type") labels.
 * Source: FDA Orange Book Data Files — Products.txt field description
 * https://www.fda.gov/drugs/drug-approvals-and-databases/orange-book-data-files
 * ("New Drug Applications (NDA or innovator) are 'N'. Abbreviated New Drug
 * Applications (ANDA or generic) are 'A'.")
 *
 * Mirrors the teCodeLabels.ts/dmfTypeLabels.ts pattern used for TE Code and
 * USDMF status: one shared lookup consumed by every surface that renders
 * `appl_type` as its own field (2026-09-23 follow-up feedback to the FDA
 * Source Product Search feature — a bare "N"/"A" carries no explanation
 * anywhere it's shown standalone).
 */
export const ORANGE_BOOK_DATA_FILES_URL =
  'https://www.fda.gov/drugs/drug-approvals-and-databases/orange-book-data-files';

export interface ApplTypeInfo {
  shortName: string;
  fullDescription: string;
}

export const APPL_TYPE_LABELS: Record<string, ApplTypeInfo> = {
  N: {
    shortName: 'NDA (innovator)',
    fullDescription: 'New Drug Applications (NDA or innovator) are coded "N".',
  },
  A: {
    shortName: 'ANDA (generic)',
    fullDescription:
      'Abbreviated New Drug Applications (ANDA or generic) are coded "A".',
  },
};

/** Resolves a raw appl_type code to its label info. Returns `undefined` for anything not N or A. */
export function getApplTypeInfo(code: string): ApplTypeInfo | undefined {
  const trimmed = code.trim().toUpperCase();
  if (!trimmed) return undefined;
  return APPL_TYPE_LABELS[trimmed];
}

/** `"[code] - [Short name]"`, or the raw code if unrecognized. */
export function formatApplType(code: string): string {
  const info = getApplTypeInfo(code);
  return info ? `${code} - ${info.shortName}` : code;
}
